import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import CIPPaginatedTable from "../CIPPaginatedTable";

import { CIP_SOURCE_OPTIONS } from "../../constants/global.constants";

import IconWithTooltip from "../../common/styles/components/headings/IconWithTooltip";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

const UserAddedCIP = () => {
  const { t } = useTranslation();
  const selectedTrain = useSelector((state) => state.selTrain);

  return (
    <div>
      <div className="ro-card-wrapper">
        <div className="ro-card-header">
          <div className="info-section">
            <div className="teal-heading">{t("CIPShutdownStrings.title")}</div>
            <IconWithTooltip label={t("helpInformation.userAddedCIPHelp")} />
          </div>
        </div>
        <div className="ag-theme-alpine">
          <CIPPaginatedTable
            selectedTrain={selectedTrain}
            source={CIP_SOURCE_OPTIONS.USER}
            exportFileName={t("excelSheetNames.cipsAndPlantShutdowns")}
            enableActions
            enableAdd
          />
        </div>
      </div>
    </div>
  );
};

export default UserAddedCIP;
